import './hero.scss';

/**
 * version    1.0
 * class      <type> (hero)
 * classdesc  Component that manage the page hero
 */
export class Hero {}
